import {PriceAlertRule} from "../../../models/rules/TradingAlertRule";
import {AlertDialogRule} from "./AlertDialogRule";
import {PriceAlertType} from "../rules/price/models/PriceAlertType";
import {TradingAlertRuleType} from "../../../models/rules/TradingAlertRuleType";

interface AlertDialogPriceRuleProperties {
    priceType: PriceAlertType;
}

export type AlertDialogPriceRule = AlertDialogPriceRuleProperties & PriceAlertRule & AlertDialogRule;

export function isDialogPriceRule(rule: AlertDialogRule): rule is AlertDialogPriceRule {
    return "type" in rule && rule.type === TradingAlertRuleType.PRICE;
}
